import React, { useContext } from 'react';

const UserInfoContext = React.createContext();

export const UserInfoProvider = UserInfoContext.Provider;
export const UserInfoConsumer = UserInfoContext.Consumer;

export const useUserInfoContext = () => useContext(UserInfoContext) || {};

export default {
  UserInfoProvider,
  UserInfoConsumer,
  useUserInfoContext
};
